import { render, staticRenderFns } from "./AddToHomeScreen.vue?vue&type=template&id=01f9f91d&scoped=true"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=js"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=js"
import style0 from "./AddToHomeScreen.vue?vue&type=style&index=0&id=01f9f91d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f9f91d",
  null
  
)

export default component.exports